import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';

const findAppContextKeyInEvent = (event: UIAnalyticsEvent): string | undefined => {
	if (!event.context) {
		return undefined;
	}

	for (const context of event.context) {
		const { appId, extensionKey } = context.forgeUIAttributes ?? {};
		if (appId && extensionKey) {
			return `${appId}/${extensionKey}`;
		}
	}
	return undefined;
};

// this filter ensures that only one event per unique appId, extensionKey pair is sent
// per user session. the goal is to reduce the volume of duplicated events sent
export const createSingleEventPerAppFilter = () => {
	const seenAppContextKeys = new Set<string>();

	return (event: UIAnalyticsEvent) => {
		try {
			const appContextKey = findAppContextKeyInEvent(event);
			if (appContextKey) {
				// only reject the event if we have clear evidence that we've seen it before
				if (seenAppContextKeys.has(appContextKey)) {
					return false;
				}
				seenAppContextKeys.add(appContextKey);
			}
		} catch {
			// in case of any error, we let the event through, so we don't accidentally break analytics
		}
		return true;
	};
};
